import {defineStore} from "pinia";
import useCrudStore from "@/store/composables/crud";
import environment from "@/environment";
import {ref} from "vue";
import httpClient from "@/tools/http-client";

export const useSignUpStore
    = defineStore('signUpStore', () => {


    const signUpUrl = environment.appConfig.baseApiUrl + "signup";
    const activationUrl = environment.appConfig.baseApiUrl + "activation";
    const crud = useCrudStore(signUpUrl);

    const userName = ref(null)
    const acceptFirst = ref(false)
    const acceptSecond = ref(false)
    const password = ref('')
    const confirmPassword = ref('')

    async function signUp(user, pwd) {
        crud.startLoading();
        try {
            const params = {
                user_name: user,
                password: pwd,
            };
            const resp = await httpClient.post(crud.endpoint.value, params);
            crud.clearLoading();
           if (resp.data.status === 'success') {
             //   await settingsStore.loadSetting();
                return;
            }
            crud.setError(resp.data.message);
        } catch (e) {
            crud.setError(e);
        }
    }

    async function doActivation(code) {
        console.log("activation");
        crud.startLoading();
        try {
            const params = {
                code,
            };
            const resp = await httpClient.post(activationUrl, params);
            crud.clearLoading();
            if (resp.data.status === 'success') {
                return resp.data.enrollment_token;
            }
            crud.setError(resp.data.message);
        } catch (e) {
            crud.setError(e);
        }
    }

    return {
        ...crud,
        userName,
        acceptFirst,
        acceptSecond,
        password,
        confirmPassword,
        signUp,
        doActivation
    }
});
